import ChannelType from './channel-type'
import ClientInputBasicInfo from './client-input-basic-info'
import ClientInputGroupClassification from './client-input-group-classification'
import ClientInputTypeOfGroup from './client-input-type-of-group'
import ClientInputAgeProfile from './client-input-age-profile'
import ClientInputFundingArrangements from './client-input-funding-arrangements'
import ClientInputProposalType from './client-input-proposal-type'

export default function FirstStep() {
    
    return (
        <div className='grid grid-cols-1 gap-3.5 lg:grid-cols-3'>
            <div className='col-span-1 rounded border border-gray-200 bg-white p-3.5 md:p-4 lg:col-span-3 '>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2 text-xs'>
                    <ChannelType />
                    <ClientInputProposalType/>
                </div>
            </div>
            <ClientInputBasicInfo />
            <div className='col-span-1 border border-gray-200 space-y-2 rounded bg-white p-3.5 md:p-4'>
                <ClientInputGroupClassification />
                {/* <hr className="h-px bg-gray-200 border-0" /> */}
                {/* <ClientInputBusinessType /> */}
            </div>
            <ClientInputTypeOfGroup />
            <div className='col-span-1 border border-gray-200 space-y-2 rounded bg-white p-3.5 md:p-4'>
                <ClientInputAgeProfile />
                <hr className="h-px bg-gray-200 border-0" />
                <ClientInputFundingArrangements />
            </div>
        </div>
    )
}
